import { Optional } from "common/utils/types";

import { IProfile } from ".";

/** Matches catalog UnavailableReason */
export const UnavailableReason = {
  ControlledStateUnfillable: "CONTROLLED_STATE_UNFILLABLE",
  ControlledDispensingBlocked: "CONTROLLED_DISPENSING_BLOCKED",
  ControlledAutoshipBlocked: "CONTROLLED_AUTOSHIP_BLOCKED",
} as const;
export type UnavailableReason = (typeof UnavailableReason)[keyof typeof UnavailableReason];

/** Matches catalog FulfillmentOption */
export type ItemFulfillmentOption = {
  kind: DeliveryMethodKind;
  is_available: boolean;
  is_low_stock: boolean;
  messages: string[];
};

/** Matches catalog DeliveryMethodKind */
export const DeliveryMethodKind = {
  Pickup: "PICKUP",
  Shipping: "SHIPPING",
  Delivery: "DELIVERY",
} as const;
export type DeliveryMethodKind = (typeof DeliveryMethodKind)[keyof typeof DeliveryMethodKind];

/** Matches fulfillments FulfillmentStatus */
export const FulfillmentStatus = {
  ReadyToPick: "READY_TO_PICK",
  ReadyToReview: "READY_TO_REVIEW",
  ReadyForPickup: "READY_FOR_PICKUP",
  ReadyToShip: "READY_TO_SHIP",
  MissedPickup: "MISSED_PICKUP",
  Completed: "COMPLETED",
  Canceled: "CANCELED",
} as const;
export type FulfillmentStatus = (typeof FulfillmentStatus)[keyof typeof FulfillmentStatus];

/** Matches fulfillments CommonFulfillmentEventSerializer */
export interface IFulfillmentEvent {
  id: number;
  status: FulfillmentStatus;
  created: string;
  user: IProfile;
  display: string;
  has_late_warning: boolean;
  days_ago_display: string;
  dismissed_at: Optional<string>;
}
